import { render, staticRenderFns } from "./TrafficTab.vue?vue&type=template&id=a50236e8&scoped=true&"
import script from "./TrafficTab.vue?vue&type=script&lang=js&"
export * from "./TrafficTab.vue?vue&type=script&lang=js&"
import style0 from "./TrafficTab.vue?vue&type=style&index=0&id=a50236e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50236e8",
  null
  
)

export default component.exports